import { render, staticRenderFns } from "./TabRekapUpahTukang.vue?vue&type=template&id=2b1f43a4&scoped=true"
import script from "./TabRekapUpahTukang.vue?vue&type=script&lang=js"
export * from "./TabRekapUpahTukang.vue?vue&type=script&lang=js"
import style0 from "./TabRekapUpahTukang.vue?vue&type=style&index=0&id=2b1f43a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1f43a4",
  null
  
)

export default component.exports